<template>
  <div class="d-flex flex-wrap h-100">
    <div class="col-6 d-flex flex-column h-100">
      <b-overlay :show="editing" :opacity="0.95" blur="5px" variant="transparent" class="d-flex flex-column w-100 h-100">
        <template #overlay>
          <div class="text-center">
            <i class="far fa-edit fa-3x"></i>
          </div>
        </template>
        <div class="d-flex flex-wrap justify-content-end">
          <b-button variant="third" class="m-1" @click="onNew"><i class="fas fa-plus"></i></b-button>
          <b-button variant="third" class="m-1" @click="onLoad"><i class="fas fa-redo-alt"></i></b-button>
        </div>
        <ag-grid-vue id="pcidic-grid"
                    class="ag-theme-alpine w-100 h-100 d-flex flex-column flex-growl-1"
                    rowSelection="single"
                    :getLocaleText="localeTextFunc"
                    :gridOptions="typeGridOptions"
                    :columnTypes="columnTypes"
                    :columnDefs="typeColumnDefs"
                    :rowData="objList"
                    :getRowId="params => params.data.id"
                    @cellDoubleClicked="onSelectRow"
                    @gridReady="onGridReady">
        </ag-grid-vue>
      </b-overlay>
    </div>
    <div v-if="editing" class="col-6 d-flex h-100">
      <b-card class="w-100 h-100 m-0 t-0">
        <template #header>
          <div class="d-flex">
            <div class="flex-grow-1"><i class="fas fa-edit text-thrid mr-1"></i><strong>{{ $lang.PCI.COPType.Title }}</strong></div>
            <div class="card-actions">
              <b-link href="#" v-if="objEdit.id" v-b-tooltip.hover :title="'Montagem'" @click="onShowMontage">
                <i class="fas fa-cogs" style="font-size:1rem;color:var(--success);"></i>
              </b-link>
              <b-link href="#" v-b-tooltip.hover :title="$lang.Common.SpreadChanges" @click="onSpreadInsert">
                <i class="fas fa-retweet" style="font-size:1rem;color:var(--success);"></i>
              </b-link>
              <b-link href="#" v-b-tooltip.hover :title="$lang.Common.Buttons.Save" @click="onSave">
                <i class="fas fa-check" style="font-size:1rem;color:var(--success);"></i>
              </b-link>
              <b-link href="#" v-if="editing" v-b-tooltip.hover :title="$lang.Common.Close" @click="onCancel">
                <i class="fas fa-times" style="font-size:1rem;color:var(--success);"></i>
              </b-link>
              <b-dropdown href="#"
                          v-if="hasRole(roles.RW_OPER_PCI_COP_ITEM_DEL) && objEdit.id && !objEdit.quantidadeCOPs"
                          variant="link"
                          class="h-100"
                          toggle-class="text-decoration-none p-0"
                          no-caret
                          tabindex="-1"
                          v-b-tooltip.hover
                          :title="$lang.Common.Tooltip.ButtonDelete">
                <template #button-content>
                  <i class="fa fa-trash text-danger p-1" style="cursor:pointer"></i>
                </template>
                <b-dropdown-header><strong>{{$lang.Common.ConfirmDelete}}</strong></b-dropdown-header>
                <b-dropdown-item href="#" v-on:click="onDelete">{{$lang.Common.Yes}}</b-dropdown-item>
                <b-dropdown-item href="#">{{$lang.Common.No}}</b-dropdown-item>
              </b-dropdown>
            </div>
          </div>
        </template>
        <b-form-group :label="$lang.PCI.COPType.LabelName">
          <b-form-input v-model="objEdit.nome"></b-form-input>
        </b-form-group>
        <b-form-group :label="$lang.PCI.COPType.LabelDescription">
          <b-form-input v-model="objEdit.descricao"></b-form-input>
        </b-form-group>
        <b-form-group :label="$lang.PCI.COPType.LabelObservation">
          <b-form-textarea v-model="objEdit.observacao" rows="4"></b-form-textarea>
        </b-form-group>
      </b-card>
    </div>
    <montage ref="montage" v-if="showMontage" :copType="objEdit" :typeList="objList" @hide="showMontage = false"></montage>
  </div>
</template>

<script>
import { AgGridVue } from 'ag-grid-vue'
import gridMixin from '../mixins/gridMixin'
import COPTypeRepository from '@/shared/http/repositories/pci/coptype'
import CompanyMixin from '@/store/module/company/mixin'
import { loading, toast } from '@/shared/utils/UIHelper'
import Tools from '@/components/tools/Tools'
import Montage from './montage.vue'
import roles from '@/shared/utils/roles'
import PermisionMixin from '@/store/module/permission/mixin'

export default {
  name: 'CopType',
  mixins: [gridMixin, CompanyMixin, PermisionMixin],
  components: {
    AgGridVue,
    Montage
  },
  data () {
    return {
      roles: roles,
      objList: [],
      objEdit: {},
      showMontage: false,
      editing: false,
      typeGridOptions: {
        headerHeight: 40,
        rowHeight: 30,
        defaultColDef: {
          filter: 'agSetColumnFilter',
          resizable: true,
          editable: false,
          suppressMenu: false,
          sortable: true,
          menuTabs: ['filterMenuTab'],
          suppressMovable: true,
          lockVisible: true,
          minWidth: 30
        }
      },
      typeColumnDefs: [
        {
          headerName: this.$lang.PCI.COPType.LabelCode,
          field: 'codigo',
          type: 'integerColumn',
          width: 30
        },
        {
          headerName: this.$lang.PCI.COPType.LabelName,
          field: 'nome',
          type: 'textColumn',
          width: 300
        },
        {
          headerName: this.$lang.PCI.COPType.LabelDescription,
          field: 'descricao',
          type: 'textColumn',
          width: 300
        },
        {
          headerName: 'Qtde. COPs',
          field: 'quantidadeCOPs',
          type: 'integerColumn',
          width: 50
        }
      ]
    }
  },
  mounted () {
    this.onLoad()
  },
  beforeMount () {
    Tools.MinimizedSidebar()
  },
  methods: {
    onLoad () {
      loading.push()
      COPTypeRepository.GetAll(this.company.id)
        .then(response => {
          if (response.data.code > 0) {
            this.objList = response.data.data
          } else {
            throw new Error(response.data.message)
          }
        })
        .catch(err => {
          console.log(err.message)
          toast.error(this.$lang.Common.Alerts.Error)
        })
        .finally(() => loading.close())
    },
    onNew () {
      this.objEdit = {}
      this.editing = true
    },
    onCancel () {
      this.objEdit = {}
      this.editing = false
    },
    onSave () {
      this.objEdit.empresaId = this.company.id
      let repository = null
      loading.push()
      if (this.objEdit.codigo) {
        repository = COPTypeRepository.Update(this.objEdit)
      } else {
        repository = COPTypeRepository.Create(this.objEdit)
      }
      repository
        .then(response => {
          if (response.data.code > 0) {
            if (this.objEdit.id) {
              const index = this.objList.findIndex(obj => obj.id === this.objEdit.id)
              this.objList.splice(index, 1, response.data.data)
            } else {
              this.objList.push(response.data.data)
              this.objList = this.objList.sort((first, second) => first.codigo - second.codigo)
              this.typeGridOptions.api.setFilterModel({})
              this.objEdit = {}
              this.editing = false
              this.$nextTick(() => {
                const row = this.typeGridOptions.api.getRowNode(response.data.data.id)
                this.typeGridOptions.api.ensureNodeVisible(row, 'middle')
                row.setSelected({newValue: true, clearSelections: true})
              })
            }
            toast.success(this.$lang.Common.Alerts.Success)
          } else {
            throw new Error(response.data.message)
          }
        })
        .catch(err => {
          console.log(err)
          toast.error(this.$lang.Common.CouldNotSave)
        })
        .finally(() => loading.close())
    },
    onDelete () {
      loading.push()
      COPTypeRepository.Delete(this.company.id, this.objEdit.id)
        .then(response => {
          if (response.data.code > 0) {
            this.objList = this.objList.filter(o => o.id !== this.objEdit.id)
            this.objEdit = {}
            this.editing = false
            toast.success(this.$lang.Common.Alerts.Success)
          } else {
            throw new Error(response.data.message)
          }
        })
        .catch(err => {
          console.log(err)
          toast.error(this.$lang.Common.CouldNotSave)
        })
        .finally(() => loading.close())
    },
    executarPropagacao () {
      loading.push()

      COPTypeRepository.SpreadInsert(this.objEdit.id)
        .then(response => {
          if (response.data.code > 0) {
            toast.success(this.$lang.Common.Alerts.Success)
          } else {
            throw new Error(response.data.message)
          }
        })
        .catch(err => {
          console.error(err)
          toast.error(this.$lang.Common.CouldNotSave)
        })
        .finally(() => loading.close())
    },
    onSpreadInsert () {
      this.$bvModal
        .msgBoxConfirm('Esta ação irá impactar em todos os COPs criados.\n\nDeseja continuar?',
          {
            title: 'Propagar Inclusão',
            size: 'md',
            buttonSize: 'sm',
            okVariant: 'success',
            okTitle: 'Sim, propagar',
            cancelVariant: 'secondary',
            cancelTitle: 'Cancelar',
            footerClass: 'p-2',
            centered: true
          }
        )
        .then(confirmed => {
          if (confirmed) {
            this.executarPropagacao()
          }
        })
        .catch(err => {
          console.error(err)
        })
    },
    onSelectRow (params) {
      if (params.node.selected) {
        this.objEdit = params.data
        this.editing = true
      }
    },
    onShowMontage () {
      if (this.typeGridOptions.api.getSelectedRows().length) {
        this.showMontage = true
        this.$nextTick(() => {
          this.$refs.montage.show()
        })
      }
    },
    onGridReady (params) {
      setTimeout(() => {
        this.typeGridOptions.api.sizeColumnsToFit()
      }, 500)
    }
  }
}
</script>

<style scoped>
.ag-theme-alpine {
  --ag-header-background-color: #008144;
  --ag-header-column-resize-handle-color: #fff0;
}
</style>



// WEBPACK FOOTER //
// src/views/private/operational/pci/coptype/coptype.vue